import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: 'Source Sans Pro', sans-serif;
    font-style: normal;
    font-weight: 600;
  }

  h1, h2, h3, h4, h5, h6, p {
    font-weight: 600;
  }

  .modal-90w {
    width: 100% !important;
    max-width: 970px;
  }

  .modal-xxl {
    width: 100% !important;
    max-width: 1300px;
  }

  .form-control:focus {
    outline: 0 !important;
    box-shadow: none !important;
  }
  .custom-select {
    border: 1px solid #787878;
  }
  .custom-select:focus {
    color: #495057 !important;
    background-color: #fff !important;
    border-color: #9654FF !important;
    outline: 0 !important;
    box-shadow: none !important;
  }
  .custom-select:hover {
    border-color: #9654FF !important;
  }
  .custom-select option {
    color: #404040;
    background: #F0F2F2;
  }
  .input-group>.form-control {
    border: 1px solid #787878;
  }
  .input-group>.form-control:hover {
    border: 1px solid #9654FF;
  }
  .input-group>.form-control:focus {
    border: 1px solid #9654FF;
  }

  // paginator
  .page-item:not(:first-child) .page-link {
    margin-left: 3px;
  }
  .page-link {
    color: #787878;
    border-color: #787878;
    box-shadow: none !important;
    &:hover {
      color: #787878;
      border-color: #787878;
      background-color: #E4E4E4;
    }
    &:focus {
      color: #787878;
      border-color: #787878;
      background-color: #E4E4E4;
    }
  }
  .active>.page-link, .page-link.active {
    background-color: #9654FF;
    color: #F0F2F2;
    border-color: #9654FF;
    &:hover {
      background-color: #9654FF;
      color: #F0F2F2;
      border-color: #9654FF;
    }
  }

  .p-datepicker {
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-shadow: none;
    z-index: 2200 !important;
    min-width: 330px;
    width: 330px;
    .p-datepicker:not(.p-datepicker-inline) {
      background: #ffffff;
      border: 1px solid rgba(0,0,0,0.15);
      box-shadow: none;
      z-index: 2200 !important;
    }

    table {
      th {
        padding: 1rem;
        text-align: center;
      }
      td {
        padding: 5px;
        span {
          width: 2.2rem;
          height: 2.2rem;
          border-radius: 5px;
          transition: box-shadow 0.15s;
          border: 1px solid transparent;
        }
      }
    }
    .p-datepicker-buttonbar {
      padding: 3px;
      border-top: 1px solid #dee2e6;
    }
  }

  .p-datepicker:not(.p-datepicker-inline) {
      background: #ffffff;
      border: 1px solid rgba(0, 0, 0, 0.15);
      box-shadow: none;
      z-index: 2200 !important;
  }
  .p-datepicker table td > span.p-highlight {
    color: #8a0538;
    background: rgba(138, 5, 56, 0.1);
    border: 1px solid #e0c8d1;
    font-weight: 600;
    box-shadow: none;
  }
  .p-datepicker .p-yearpicker .p-yearpicker-year.p-highlight {
    color: #8a0538;
    background: rgba(138, 5, 56, 0.1);
    border: 1px solid #e0c8d1;
    font-weight: 600;
  }
  .p-datepicker table td.p-datepicker-today > span.p-highlight {
    color: #ffffff;
    background: #8a0538;
    box-shadow: none;
  }
  .p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year:enabled:hover, .p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month:enabled:hover {
    color: #8a0538;
  }
  .p-inputtext {
    font-family: 'Source Sans Pro', sans-serif;
    height: 48px;
    box-sizing: border-box;
    font-size: 1rem;
    color: #495057;
    appearance: none;
    border-radius: 4px;
    border: 1px solid #787878 !important;
    &:enabled:hover {
      border-color: #9654ff !important;
      box-shadow: none;
    }
    &:enabled:focus {
      border-color: #9654ff !important;
      box-shadow: none;
    }
  }

  .p-datepicker .p-monthpicker .p-monthpicker-month.p-highlight {
    color: #8a0538;
    background: rgba(138, 5, 56, 0.1);
    border: 1px solid #e0c8d1;
    font-weight: 600;
  }

  .p-datepicker:not(.p-datepicker-inline) .p-datepicker-header {
    padding: 0;
    background: #ffffff !important;
    border: 1px solid #d3d3d3;
  }

  .p-button.p-button-secondary.p-button-text, .p-buttonset.p-button-secondary > .p-button.p-button-text, .p-splitbutton.p-button-secondary > .p-button.p-button-text, .p-fileupload-choose.p-button-secondary.p-button-text {
    background-color: transparent;
    color: #6c757d;
    font-weight: 600;
    border-color: transparent;
    &:enabled:hover {
      background-color: transparent;
      border-color: transparent;
      color: #8a0538;
      box-shadow: none;
    }
    &:enabled:focus {
      background-color: transparent;
      border-color: transparent;
      color: #8a0538;
      box-shadow: none;
    }
  }

  // FULL CALENDAR
  .fc.fc-theme-standard .fc-toolbar .fc-button-group .fc-button {
    background-color: transparent;
    border: transparent;
    color: #9654FF;
  }

  .fc .fc-daygrid-day-top {
    flex-direction: row;
    > a {
        text-decoration: auto;
        color: #787878;
    }
  }

  .fc .fc-col-header-cell-cushion {
      color: #404040;
      text-decoration: auto;
      width: 100%;
  }

  .fc.fc-theme-standard .fc-view-harness th {
    background: #fff;
    border: #F0F2F2;
    color: #404040;
    height: 50px;
  }

  .fc .fc-daygrid-day.fc-day-today {
    background-color: transparent;
  }

  .fc .fc-toolbar.fc-header-toolbar {
    margin: 0;
    height: 80px;
    background-color: #f0f2f2;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
    @media (max-width: 1100px) {
      height: 150px;
    }
  }

  .fc.fc-theme-standard .fc-view-harness .fc-scrollgrid {
    border-color: #F0F2F2;
  }

  .fc.fc-theme-standard .fc-toolbar .fc-button {
    background-color: transparent;
    border: transparent;
    height: 40px;
    color: #404040;
    background: #FFFFFF;
    border: 1px solid #E4E4E4;
    border-radius: 8px;
    &:enabled:hover {
      background-color: transparent;
      border: transparent;
      color: #404040;
    }
    &:enabled:focus {
      background-color: transparent;
      border: transparent;
      color: #404040;
    }
    &:enabled:active {
      background-color: transparent;
      border: transparent;
      color: #404040;
    }
    &:focus {
      box-shadow: none !important;
    }
    &:disabled {
      background: #FFFFFF;
      border: 1px solid #E4E4E4;
      border-radius: 8px;
      margin-left: 15px;
      color: #404040;
    }
  }

  .rbt-close-content{
    display: none;
  }

  .modal-sm {
    --bs-modal-width: 379px;
  }

  .fc.fc-theme-standard
  .fc-toolbar
  .fc-button.fc-dayGridMonth-button {
    color: #787878;
    background: #FFFFFF;
    width: 80px;
    height: 32px;
    border: 1px solid #E4E4E4;
    border-radius: 0px 8px 8px 0px;
    margin: 0px;
    margin-right: 24px;
    padding: 0;
    border-top-right-radius: 8px !important;
    border-bottom-right-radius: 8px !important;
    font-size: 14px;
    line-height: 100%;
    &:enabled:focus {
      color: #404040;
      background: #E4E4E4;
    }
  }

  .fc.fc-theme-standard
  .fc-toolbar
  .fc-button.fc-timeGridWeek-button {
    color: #787878;
    background: #FFFFFF;
    width: 80px;
    height: 32px;
    border: 1px solid #E4E4E4;
    padding: 0;
    margin: 0px;
    font-size: 14px;
    line-height: 100%;
    &:enabled:focus {
      color: #404040;
      background: #E4E4E4;
    }
  }

  .fc.fc-theme-standard
  .fc-toolbar
  .fc-button.fc-timeGridDay-button {
    color: #787878;
    background: #FFFFFF;
    width: 80px;
    height: 32px;
    border: 1px solid #E4E4E4;
    border-radius: 8px 0px 0px 8px;
    padding: 0;
    margin: 0px;
    border-top-left-radius: 8px !important;
    border-bottom-left-radius: 8px !important;
    font-size: 14px;
    line-height: 100%;
    &:enabled:focus {
      color: #404040;
      background: #E4E4E4;
    }
  }

  .fc.fc-theme-standard .fc-toolbar .fc-button.fc-dayGridMonth-button.fc-button-active, .fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridWeek-button.fc-button-active, .fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridDay-button.fc-button-active {
    background: #E4E4E4;
    border-color: #E4E4E4;
    color: #404040;
  }

  .fc .fc-timegrid-slot {
    height: 45px !important;
  }

  .fc .fc-timegrid-slot-label {
      border-bottom: 0px;
      border-top: 0px;
  }

  .fc-button-group .fc-legend-button {
    color: #404040 !important;
  }

  .fc-button-group .fc-legend2-button {
    color: #404040 !important;
    padding-left: 0px;
  }

  .fc-button-group .fc-legend-button:focus {
      box-shadow: none !important;
  }

  .fc-button-group .fc-legend2-button:focus {
      box-shadow: none !important;
  }

  .fc-icon-pi {
    font-family: primeicons !important;
    font-size: 0.85em !important;
  }

  .background-leave {
    &:hover {
      background: #0000000d;
      border-radius: 6px;
    }
  }

  .fc-event .fc-timegrid-event-harness-inset .fc-timegrid-event {
    border-radius: 6px;
    padding: 2px;
  }

  .antecipacaoClassName {
    border-left: 6px solid #057c84 !important;
  }

  .substituicaoClassName {
    border-left: 6px solid #3907ff !important;
  }

  .reposicaoClassName {
    border-left: 6px solid #ff7d04 !important;
  }

  /* Define css class for global loading message to cover
  screen during axios operations */
  .loading {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 9999;
    color: #8a0538;
    gap: 32px;
    background: #00000020;
  }
    
.otnotice {
    font-family: "Source Sans Pro", sans-serif;
    color: #404040;
    line-height: 1.6;
    padding: 16px;
}
.otnotice h2 {
    color: rgb(138, 5, 56);
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
}

.otnotice p {
    font-size: 16px;
}
    .ot-form-wrapper {
       max-width: 100%;
       height: auto;
       min-height: 400px;
        border: 1px solid #c0c2c7;
        margin: auto;
    }
    .ot-form-wrapper iframe {
        width: 100%;
        height: 100%;
        border: none;
    }


  .custom-loader {
    --d:18px;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    color: #8a0538;
    box-shadow: 
      calc(1*var(--d))      calc(0*var(--d))     0 1px,
      calc(0.707*var(--d))  calc(0.707*var(--d)) 0 1px,
      calc(0*var(--d))      calc(1*var(--d))     0 1px,
      calc(-0.707*var(--d)) calc(0.707*var(--d)) 0 1px,
      calc(-1*var(--d))     calc(0*var(--d))     0 1px,
      calc(-0.707*var(--d)) calc(-0.707*var(--d))0 1px,
      calc(0*var(--d))      calc(-1*var(--d))    0 2.5px;
    animation: s7 2s infinite steps(8);
  }
  
  @keyframes s7 {
    100% {transform: rotate(1turn)}
  }

  .container-none {
    display: none;
  }

  /* Global CSS configuration for scrollbar */
  ::-webkit-scrollbar-track {
        background-color: #fff;
    }

  ::-webkit-scrollbar {
      width: 8px;
  }

  ::-webkit-scrollbar-thumb {
      background: #e4e4e4;
      border-radius: 5px;
  }

  /*Dialog ClassName */
  .visible-dialog {
    display: block !important;
  }

  .hidden-dialog {
    display: none !important;
  }

  .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-item.show .nav-link.active {
    border-color: none !important;
  }

  .svg-icon {
    width: 18px;
    height: 18px;
  }

  .svg-icon-margin {
    margin: 3px;
  }

  .modal-create-card {
    width: 100% !important;

    .modal-dialog {
        max-width: 1100px !important;
    }

    .modal-create-card-autocomplete {
        max-width: 100% !important;
    }
  }

  .bold-placeholder > div > input::placeholder {
    font-weight: 600;
    color: #212529;
  }
`;

export default GlobalStyle;
